"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/message/v1/cms_common.proto (package spwn.message.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSMessageDmMessage = exports.CMSMessageDmMessageTextWithFile = exports.CMSMessageDmMessageFile = exports.CMSMessageDmMessageText = exports.CMSMessageDmMessageBody = exports.CMSMessageCoreFanFilterIncludeOrExclude = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * CMS画面からDM一斉送信を行う際に、
 * user_id_listに含まれるuserに送る or user_id_listに含まれないuserに送るのかを制御する
 *
 * @generated from enum spwn.message.v1.CMSMessageCoreFanFilterIncludeOrExclude
 */
var CMSMessageCoreFanFilterIncludeOrExclude;
(function (CMSMessageCoreFanFilterIncludeOrExclude) {
    /**
     * @generated from enum value: CMS_MESSAGE_CORE_FAN_FILTER_INCLUDE_OR_EXCLUDE_UNSPECIFIED = 0;
     */
    CMSMessageCoreFanFilterIncludeOrExclude[CMSMessageCoreFanFilterIncludeOrExclude["CMS_MESSAGE_CORE_FAN_FILTER_INCLUDE_OR_EXCLUDE_UNSPECIFIED"] = 0] = "CMS_MESSAGE_CORE_FAN_FILTER_INCLUDE_OR_EXCLUDE_UNSPECIFIED";
    /**
     * @generated from enum value: CMS_MESSAGE_CORE_FAN_FILTER_INCLUDE_OR_EXCLUDE_INCLUDE = 1;
     */
    CMSMessageCoreFanFilterIncludeOrExclude[CMSMessageCoreFanFilterIncludeOrExclude["CMS_MESSAGE_CORE_FAN_FILTER_INCLUDE_OR_EXCLUDE_INCLUDE"] = 1] = "CMS_MESSAGE_CORE_FAN_FILTER_INCLUDE_OR_EXCLUDE_INCLUDE";
    /**
     * @generated from enum value: CMS_MESSAGE_CORE_FAN_FILTER_INCLUDE_OR_EXCLUDE_EXCLUDE = 2;
     */
    CMSMessageCoreFanFilterIncludeOrExclude[CMSMessageCoreFanFilterIncludeOrExclude["CMS_MESSAGE_CORE_FAN_FILTER_INCLUDE_OR_EXCLUDE_EXCLUDE"] = 2] = "CMS_MESSAGE_CORE_FAN_FILTER_INCLUDE_OR_EXCLUDE_EXCLUDE";
})(CMSMessageCoreFanFilterIncludeOrExclude || (exports.CMSMessageCoreFanFilterIncludeOrExclude = CMSMessageCoreFanFilterIncludeOrExclude = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSMessageCoreFanFilterIncludeOrExclude)
protobuf_1.proto3.util.setEnumType(CMSMessageCoreFanFilterIncludeOrExclude, "spwn.message.v1.CMSMessageCoreFanFilterIncludeOrExclude", [
    { no: 0, name: "CMS_MESSAGE_CORE_FAN_FILTER_INCLUDE_OR_EXCLUDE_UNSPECIFIED" },
    { no: 1, name: "CMS_MESSAGE_CORE_FAN_FILTER_INCLUDE_OR_EXCLUDE_INCLUDE" },
    { no: 2, name: "CMS_MESSAGE_CORE_FAN_FILTER_INCLUDE_OR_EXCLUDE_EXCLUDE" },
]);
/**
 * @generated from message spwn.message.v1.CMSMessageDmMessageBody
 */
class CMSMessageDmMessageBody extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof spwn.message.v1.CMSMessageDmMessageBody.body
         */
        this.body = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSMessageDmMessageBody().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSMessageDmMessageBody().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSMessageDmMessageBody().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSMessageDmMessageBody, a, b);
    }
}
exports.CMSMessageDmMessageBody = CMSMessageDmMessageBody;
CMSMessageDmMessageBody.runtime = protobuf_1.proto3;
CMSMessageDmMessageBody.typeName = "spwn.message.v1.CMSMessageDmMessageBody";
CMSMessageDmMessageBody.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "text", kind: "message", T: CMSMessageDmMessageText, oneof: "body" },
    { no: 2, name: "file", kind: "message", T: CMSMessageDmMessageFile, oneof: "body" },
    { no: 3, name: "text_with_file", kind: "message", T: CMSMessageDmMessageTextWithFile, oneof: "body" },
]);
/**
 * @generated from message spwn.message.v1.CMSMessageDmMessageText
 */
class CMSMessageDmMessageText extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string content = 1;
         */
        this.content = "";
        /**
         * メッセージをpostする時にはlink, getする時には, iframelyで生成されたhtmlが入る
         *
         * @generated from field: repeated string ogp_cark_link_or_html = 2;
         */
        this.ogpCarkLinkOrHtml = [];
        /**
         * messageをhtmlにレンダリングしたもの. お知らせメールで使用
         *
         * @generated from field: string html_content = 3;
         */
        this.htmlContent = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSMessageDmMessageText().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSMessageDmMessageText().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSMessageDmMessageText().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSMessageDmMessageText, a, b);
    }
}
exports.CMSMessageDmMessageText = CMSMessageDmMessageText;
CMSMessageDmMessageText.runtime = protobuf_1.proto3;
CMSMessageDmMessageText.typeName = "spwn.message.v1.CMSMessageDmMessageText";
CMSMessageDmMessageText.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ogp_cark_link_or_html", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "html_content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.message.v1.CMSMessageDmMessageFile
 */
class CMSMessageDmMessageFile extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string file_url = 1;
         */
        this.fileUrl = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSMessageDmMessageFile().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSMessageDmMessageFile().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSMessageDmMessageFile().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSMessageDmMessageFile, a, b);
    }
}
exports.CMSMessageDmMessageFile = CMSMessageDmMessageFile;
CMSMessageDmMessageFile.runtime = protobuf_1.proto3;
CMSMessageDmMessageFile.typeName = "spwn.message.v1.CMSMessageDmMessageFile";
CMSMessageDmMessageFile.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "file_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.message.v1.CMSMessageDmMessageTextWithFile
 */
class CMSMessageDmMessageTextWithFile extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string content = 1;
         */
        this.content = "";
        /**
         * @generated from field: string file_url = 2;
         */
        this.fileUrl = "";
        /**
         * メッセージをpostする時にはlink, getする時には, iframelyで生成されたhtmlが入る
         *
         * @generated from field: repeated string ogp_cark_link_or_html = 3;
         */
        this.ogpCarkLinkOrHtml = [];
        /**
         * messageをhtmlにレンダリングしたもの. お知らせメールで使用
         *
         * @generated from field: string html_content = 4;
         */
        this.htmlContent = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSMessageDmMessageTextWithFile().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSMessageDmMessageTextWithFile().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSMessageDmMessageTextWithFile().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSMessageDmMessageTextWithFile, a, b);
    }
}
exports.CMSMessageDmMessageTextWithFile = CMSMessageDmMessageTextWithFile;
CMSMessageDmMessageTextWithFile.runtime = protobuf_1.proto3;
CMSMessageDmMessageTextWithFile.typeName = "spwn.message.v1.CMSMessageDmMessageTextWithFile";
CMSMessageDmMessageTextWithFile.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ogp_cark_link_or_html", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "html_content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.message.v1.CMSMessageDmMessage
 */
class CMSMessageDmMessage extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 一斉送信するファンのidを持ったlist
         *
         * @generated from field: repeated string user_id_list = 1;
         */
        this.userIdList = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSMessageDmMessage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSMessageDmMessage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSMessageDmMessage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSMessageDmMessage, a, b);
    }
}
exports.CMSMessageDmMessage = CMSMessageDmMessage;
CMSMessageDmMessage.runtime = protobuf_1.proto3;
CMSMessageDmMessage.typeName = "spwn.message.v1.CMSMessageDmMessage";
CMSMessageDmMessage.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_id_list", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "body", kind: "message", T: CMSMessageDmMessageBody },
]);
//# sourceMappingURL=cms_common_pb.js.map